/**
 * Full Stack FastAPI MARIADB
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * A class that represents the thumbnail URL of a video. Attributes: small: The small thumbnail URL. large: The large thumbnail URL. The small thumbnail URL is used for the video list. The large thumbnail URL is used for the video player.
 */
export interface VideoThumbnailUrlDTO { 
    small: string;
    large: string;
}

